import { METHOD_TYPES } from "../../../stateCommon/consts";
const getPublishStatusCode = () => `
  async (id = source.formData.id) => {
      if(!id) return;
      const statusResult = await source.$requests.getPublishStatus({body:{ids:[id]}})
      if(statusResult.body.code === 0) {
        const [publishStatus] = statusResult.body.data
         source.publishStatus = publishStatus.status
        return source
      }
    }
 `;
export const generateGetPublishStatusMethod = options => ({
  id: 'publishStatus',
  title: '获取发布状态',
  code: getPublishStatusCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code
});
//# sourceMappingURL=form.js.map
